import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  NOT_FOUND_HOME_CTA_TEXT,
  NOT_FOUND_META_TITLE,
  NOT_FOUND_PAGE_BODY,
  NOT_FOUND_PAGE_TITLE,
  NOT_FOUND_PAGE_TITLE_CAPTION,
  NOT_FOUND_RESORTS_CTA_TEXT,
  ACCOUNT_HOME_PATH,
  MK_RESORTS_PATH,
} from '@constants'
import Container from '@ui/Container/Container'
import SectionTitle from '@ui/SectionTitle/SectionTitle'
import PageMeta from '@layout/PageMeta'
import { useBreakpoint } from '@hooks/useBreakpoint'
import { Illustration } from '@ui/Illustration'
import { useSiteContext } from '@contexts/MkSiteContext'
import { ZinButton } from '@tnl/zin-react'
import './PageNotFound.scss'

const PageNotFound = () => {
  const navigate = useNavigate()
  const { isMobile } = useBreakpoint()
  const { themeBrand: brand } = useSiteContext()
  const meta = {
    title: NOT_FOUND_META_TITLE,
  }
  return (
    <div className="page-not-found">
      <PageMeta meta={meta} />
      <Container className="page-not-found__container">
        <SectionTitle
          caption={NOT_FOUND_PAGE_TITLE_CAPTION}
          className="page-not-found__section-title"
          title={NOT_FOUND_PAGE_TITLE}
          titleTag="h1"
        />
        <div className="page-not-found__illustration">
          <Illustration
            brand={brand}
            name="exit-page"
            width={80}
            alt="Exit Page"
          />
        </div>
        <div className="page-not-found__body">{NOT_FOUND_PAGE_BODY}</div>
        <div className="page-not-found__actions">
          <ZinButton
            full={isMobile}
            onClick={() => navigate(ACCOUNT_HOME_PATH)}
            variant="secondary">
            {NOT_FOUND_HOME_CTA_TEXT}
          </ZinButton>
          <ZinButton
            full={isMobile}
            onClick={() => navigate(MK_RESORTS_PATH)}
            variant="secondary">
            {NOT_FOUND_RESORTS_CTA_TEXT}
          </ZinButton>
        </div>
      </Container>
    </div>
  )
}

export default PageNotFound
